import { Component, OnInit, HostListener } from '@angular/core';
import { StaffService } from 'src/app/services/staff/staff.service';
import { Select2OptionData } from 'ng2-select2';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TimeSheetService } from 'src/app/services/time-sheet.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import { LocationStrategy, Location } from '@angular/common';
import { timePeriodLists } from '../../_models/staticArray';

import * as _ from 'lodash'
import { map } from 'rxjs/operators';


@Component({
  selector: 'app-admin-time-sheet',
  templateUrl: './admin-time-sheet.component.html',
  styleUrls: ['./admin-time-sheet.component.scss']
})


export class AdminTimeSheetComponent implements OnInit {

  public current: string;
  queryParamsObj = {};
  displayMessage = false;
  hide: boolean = false;
  selectedIndex: any;

  isPrint: boolean;
  isAdmin: boolean = false;
  filter$: Observable<string>;
  selectedStaffUser = ''
  @HostListener('window:beforeprint', ['$event'])
  onBeforePrint(event) {
    this.isPrint = true;
  }
  @HostListener('window:afterprint', ['$event'])
  onAfterPrint(event) {
    this.isPrint = false
  }
  timePeriods = timePeriodLists
  selectedTime = 'weekly'
  dashboardTitle
  _isView = false
  pageType
  constructor(private _staffService: StaffService, private _timeSheetService: TimeSheetService,
    public route: ActivatedRoute, private router: Router, public dialog: MatDialog, public _snackBar: MatSnackBar,
    private locationStrategy: LocationStrategy,
    private _location: Location) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    let currentUser: any = JSON.parse(localStorage.getItem('currentUser'))
    console.log('currentUser', currentUser)
    if (currentUser && (currentUser.userRole.includes('admin') || currentUser.userRole.includes('manager')))
      this.isAdmin = true

    this.selectedIndex = 0;
    this.route.queryParams.subscribe(params => {
      console.log("params in admin time sheet page", params);
      this.pageType = params.type

      if (this.pageType === 'dashboard') {
        this._isView = false
        this.dashboardTitle = 'Continue to Fatigue'
      }
      if (this.pageType === 'list') {
        this._isView = true
        this.dashboardTitle = 'Continue to Fatigue Dashboard'
      }


      if (params.currentTab) {
        this.selectedIndex = params.currentTab
      } else {
        // this.updateQueryParams(0)
        // this.updateQueryParams({ type: this.pageType, currentTab: this.selectedIndex, user: this.selectedStaffUser })
      }
    });

    console.log("CURRENT SELECTED INDEX", this.selectedIndex)
  }

  getCurrentWeekDates() {
    return new Promise((resolve, reject) => {
      let today = moment()
      let currentWeek = moment().week()
      let weekStartDate = moment().startOf('isoWeek').isoWeek(currentWeek);
      if (weekStartDate < moment().startOf('year')) weekStartDate = moment().startOf('year');
      let weekEndDate = moment().endOf('isoWeek').isoWeek(currentWeek);
      if (weekEndDate > moment().endOf('year')) {
        weekEndDate = moment().endOf('year')
      }
      let dates = []
      dates.push(weekStartDate.format('MM/DD/YYYY'))
      while (weekStartDate.add(1, 'days').diff(weekEndDate) < 0) {
        console.log(weekStartDate.toDate());
        dates.push(weekStartDate.clone().format('MM/DD/YYYY'));
      }
      resolve(dates)
    })
  }
  getWeekDates(week) {

    let dates = []

    while (week.weekStartDate.add(1, 'days').diff(week.weekEndDate) < 0) {
      console.log(week.weekStartDate.toDate());
      dates.push(week.weekStartDate.clone().format('MM/DD/YYYY'));
    }
    console.log("dates:", dates);
  }


  printing(event) {
    console.log("**IS PRINTING**", event);
    if (event.msg == 'printing') {
      this.hide = true;
      if (this.hide) $('.mat-tab-header').hide()
      else $('.mat-tab-header').show()
      // $('#tabLabel').addClass('opacity')
      // this.print.emit({ msg: 'printing' })
    }
    else if (event.msg == 'printing complete') {
      // this.hide = false
      $('.mat-tab-header').show()
    }
  }
  checkParams() {
    this.route.queryParamMap.subscribe(params => {
      let paramsObject = { ...params.keys, ...params };
      console.log("params in admin time sheet page", params, paramsObject);

      // if (params.currentTab) {
      //   this.selectedIndex = params.currentTab
      // } else {
      //   this.updateQueryParams(0)
      // }
    });

    let params = this.route.snapshot


    this.filter$.subscribe(param => {
      console.log("What is the value of param", param);

    })
  }


  tabChanged(event) {
    console.log("**tab changed", event);
    this.selectedIndex = event.index
    this.updateQueryParams({ type: this.pageType, currentTab: this.selectedIndex, user: this.selectedStaffUser })
  }


  selectStaffUser(event) {
    console.log("Event of staff User emit", event);
    this.selectedStaffUser = event
    this.updateQueryParams({ type: this.pageType, currentTab: this.selectedIndex, user: this.selectedStaffUser })
  }

  updateQueryParams(obj) {
    // this.filter$.subscribe(param => {
    // console.log("What is the value of params update", param);
    this._location.replaceState(
      this.router.createUrlTree(
        [this.locationStrategy.path().split('?')[0]], // Get uri
        {
          relativeTo: this.route, queryParams: obj
        }
      ).toString()
    );
    // });
  }


  // Utility functions
  openDialog(someComponent, data = {}): Observable<any> {
    console.log('OPENDIALOG', 'DATA = ', data)
    const dialogRef = this.dialog.open(someComponent, { data });

    return dialogRef.afterClosed();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }



  changeTimePeriod() {
    console.log("WHEN TIME PERIOD CHANGE", this.selectedTime)
  }

  competencyTypeChange() {
    this._isView = !this._isView
    let queryParams
    if (!this._isView) {
      this.dashboardTitle = 'Continue to Fatigue'
      queryParams = { type: 'dashboard' }
      this.pageType = 'dashboard'
      this.updateQueryParams({ type: this.pageType })
    }
    if (this._isView) {
      this.dashboardTitle = 'Continue to Fatigue Dashboard'
      queryParams = { type: 'list' }
      this.pageType = 'list'
      this.updateQueryParams({ type: this.pageType, currentTab: this.selectedIndex, user: this.selectedStaffUser })
    }
    // this._router.navigate(
    //   [],
    //   {
    //     relativeTo: this._route,
    //     queryParams: queryParams,
    //     queryParamsHandling: 'merge', // remove to replace all query params by provided
    //   });

  }
}
